module.exports = __webpack_public_path__ + "img/moon-star.eb4baaa6.svg";